import {
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  OnChangeFn,
  PaginationState,
  useReactTable,
} from "@tanstack/react-table"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { Table } from "~/components/table/Table.tsx"
import { PAGE_SIZE } from "~/pages/Brand/Suppliers/List/SupplierRisk/SupplierRiskWrapper.tsx"
import { useColumns } from "~/pages/Brand/Suppliers/List/SupplierRisk/columns.tsx"

interface Props {
  suppliersData: LibraryResponses.SupplierRiskResponse
  pagination: PaginationState
  setPagination: OnChangeFn<PaginationState>
}

export const SuppliersRisk = ({
  suppliersData,
  pagination,
  setPagination,
}: Props) => {
  const [pageCount, setPageCount] = useState(1)
  const { count, suppliers } = suppliersData
  const [searchParams] = useSearchParams()
  const urlSearch = searchParams.get("search")
  const [search, setSearch] = useState(urlSearch ?? "")
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  useEffect(() => {
    setPageCount(Math.ceil(count / PAGE_SIZE))
  }, [count])
  const columns = useColumns()
  const table = useReactTable({
    data: suppliers,
    columns,
    initialState: {
      pagination: {
        pageIndex: 1,
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      globalFilter: search,
      columnFilters,
      pagination,
    },
    pageCount,
    manualPagination: true,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setSearch,
    getCoreRowModel: getCoreRowModel(),
    onColumnFiltersChange: setColumnFilters,
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  })
  return (
    <Table
      table={table}
      pagination={true}
      manualPaginationCount={count}
      pageIndex={pagination.pageIndex}
    />
  )
}
